import { StationPageWrapper } from '@app/core/routing/StationPageWrapper';
import { SearchPage } from '../screens/view/SearchPage';

export function SearchScreenAdapterPage() {
  return (
    <StationPageWrapper>
      <SearchPage />
    </StationPageWrapper>
  );
}
